const SiteAdminNotFoundTemplate = () => {
  return (
    <div className="flex items-center justify-center h-full">
      <div className="flex items-center pt-8">
        <div className="px-4 text-lg text-gray-400 border-r border-gray-300 tracking-wider">
          404
        </div>

        <div className="ml-4 text-lg text-gray-400 uppercase tracking-wider">
          Not Found
        </div>
      </div>
    </div>
  );
};

export default SiteAdminNotFoundTemplate;
